<template>
  <div class="about_banner">
    <div class="banner_item">
      <img v-if="isKK" :src="require('/src/assets/kkaboutaa.png')" />
      <img v-else :src="require('/src/assets/about.jpg')" />
    </div>
  </div>
  <div class="contaier content">
    <div class="inner">
      <div class="content_title">
        <div class="flex title1">
          <div class="flex-item left">
            <span class="line_"></span>
          </div>
          <div class="text">
            <span>公司</span>
            <span class="red">介绍</span>
          </div>
          <div class="flex-item right">
            <span class="line_"></span>
          </div>
        </div>
        <div class="title2">INTRODUCTION</div>
      </div>
      <div class="about">
        <div class="flex-item about_panel1 flex" style="justify-content: center">
          <div class="about_img">
            <img :src="this.imgUrl" />
          </div>
          <div style="width: 49%">
            <div class="flex about_panel1">
              <div class="flex-item about_desc">
                <div class="about_title">{{ this.name }}</div>
                <div class="about_line flex">
                  <div class="about_filed">公司简介:</div>
                  <div class="flex-item about_filed_value">{{ this.content }}</div>
                </div>
                <div class="about_line flex">
                  <div class="about_filed">使命愿景:</div>
                  <div class="flex-item about_filed_value">
                    面向未来，{{ this.vision }}始终怀揣「助力工业企业转型升级」的企业愿景，以全面深入的平台化服务覆盖转型全流程，致力于成为国内领先的数字化与自动化深度融合的全链条解决方案服务商，为中国工业数字化、智能化发展注入持续动能。
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 30px"></div>
        <div class="flex-item about_desc_">
          <div class="about_desc_item">
            <p>核心业务</p>
            <div class="flex">
              <div style="width: 28%">
                <span class="jachu">自动化产品及机器人：</span><br />
                公司提供全面的自动化产品配件，和机械设备涵盖包装机、理袋机、开装箱一体机、协作码垛机器人、AGV
                机器人、工业视觉系统等并提供相应的服务方案和技术支持。为推动工业4.0提供全面的服务。<br />
              </div>
              <div style="margin-left: 3%; margin-right: 3%; width: 31%">
                <span class="jachu">自动化改造服务：</span><br />
                公司提供全面的自动化改造解决方案，包括工业自动化控制系统、智能传感器、数据采集与监控系统（SCADA）、制造执行系统（MES）等。通过这些技术，帮助企业实现生产过程的自动化和智能化，提升整体运营效率。<br />
              </div>
              <div style="width: 36%">
                <span class="jachu">智慧工厂：</span><br />
                公司专注于智慧工厂的建设与优化，通过物联网（IoT）、大数据分析、人工智能（AI）等技术，帮助企业实现生产过程的全面数字化和智能化。公司提供从规划、设计到实施、维护的全流程服务，助力企业打造高效、灵活、可持续的智慧工厂。<br />
              </div>
            </div>
          </div>
          <!-- <div class="about_desc_item_split"></div>
          <div class="about_desc_item">
            <p>技术优势</p>
            <span class="jachu">强大的研发能力：</span><br />
            公司拥有一支由资深工程师和研究人员组成的团队，专注于自动化和智慧城市领域的技术创新。<br />
            <span class="jachu">自主知识产权：</span><br />
            公司拥有多项自主知识产权和专利技术，确保解决方案的先进性和独特性。<br />
            <span class="jachu">灵活的定制服务：</span><br />
            根据客户的具体需求，提供定制化的解决方案，确保技术与业务的深度结合。
          </div> -->
          <div class="about_desc_item_split"></div>
          <div class="about_desc_item">
            <p>市场定位</p>
            {{
              this.vision
            }}定位于自动化、智慧工厂和智慧城市解决方案提供商，主要服务于制造业、能源行业、市政建设等领域的企业及政府机构。公司凭借其技术实力和丰富的行业经验，已在市场上建立了良好的声誉和强大的竞争力。<br />
          </div>
          <div class="about_desc_item_split"></div>
          <div class="about_desc_item">
            <p>服务范围</p>
            <div class="flex">
              <div style="margin-right: 2%; width: 44%">
                <span class="jachu">行业覆盖：</span><br />
                为航空航天、电子制造、汽车生产、能源环保、太阳能、石油化工、轨道交通，工厂自动化生产线等国内众多客户提供产品集中采购及自动化解决方案整包服务。<br />
              </div>
              <div style="margin-left: 2%; width: 44%">
                <span class="jachu">地域分布：</span><br />
                公司业务覆盖全国多个省市，并积极拓展国际市场，为客户提供全球化服务。
              </div>
            </div>
          </div>
          <div class="about_desc_item_split"></div>
          <div class="about_desc_item">
            <p>团队与合作伙伴</p>
            <div class="flex">
              <div style="width: 25%">
                <span class="jachu">管理团队：</span><br />
                公司拥有一支经验丰富的管理团队，具备深厚的行业背景和卓越的领导能力，确保公司战略目标的实现。<br />
              </div>
              <div style="margin-left: 4%; margin-right: 4%; width: 25%">
                <span class="jachu">技术团队：</span><br />
                由一群在自动化、物联网等领域的资深专家组成，致力于技术研发和创新，确保公司技术的领先地位。<br />
              </div>
              <div style="width: 40%">
                <span class="jachu">合作伙伴：</span><br />
                公司长期与西门子、施耐德、欧姆龙、三萎、明纬、ABB、松下、和泉、SMC、亚德客、魏德米勒、昆仑通态、威纶通、德力西、正泰、雷普等国内外知名电气企业保持良好的战略合作关系。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgUrl: "",
      name: "",
      content: "",
      vision: "",
      isKK: true,
    };
  },
  mounted() {
    const host = window.location.host;
    this.isKK = host.includes("fjkkauto");
    this.imgUrl = this.isKK
      ? require("../../assets/kkabout.png")
      : require("../../assets/kctdabout.png");
    this.name = this.isKK ? "福建科控自动化科技有限公司" : "北京凯创通达科技有限公司";
    this.content = this.isKK
      ? " 福建科控自动化科技有限公司成立于2012年，立足东南科创热土，深耕工业数智蓝海，福建科控科技十余年来始终锚定工业企业数字化智能化转型赛道，以技术为笔、以服务为墨，绘就工业升级新蓝图。自成立以来，我们始终坚守诚信、创新、专业的核心价值观：以诚信为立业之基，对客户坦诚相待、对品质坚守承诺；以创新为发展引擎，持续深耕人工智能、工业自动化、大数据云计算等前沿技术领域；以专业为服务底色，沉淀十余年行业实践经验，打磨过硬的技术服务团队。我们具备雄厚的研发实力，深厚的行业知识沉淀，构建了覆盖自动化、数字化的全场景完整解决方案矩阵，已帮助数十家工业企业完成数智化升级改造，实现降本增效的发展目标。"
      : "北京凯创通达科技有限公司成立于2017年，坐落于北京副中心CBD中央商务区。是一家从事工业自动化产品销售、设计研发，系统集成、并提供一站式设备解决方案为一体的现代化科技创新企业。公司由一群具有丰富行业经验的专业人士创立，旨在通过技术创新和优质服务，成为自动化和智慧工厂领域的领导者。";
    this.vision = this.isKK ? "科控科技" : "凯创通达";
  },
  methods: {},
};
</script>

<style>
.about_banner {
  height: 500px;
}

.about_banner img {
  width: 100%;
  height: 460px;
}

.content {
  /* padding-top: 50px; */
  padding-bottom: 50px;
}

.content_title .left {
  line-height: 30px;
  text-align: right;
}

.content_title .right {
  line-height: 30px;
  text-align: left;
}

.content_title .text {
  width: 150px;
  line-height: 30px;
  text-align: center;
}

.content_title .line_ {
  width: 100px;
  background: #000;
  display: inline-block;
  height: 2px;
}

.content_title .title1 {
  height: 40px;
  line-height: 40px;
  font-size: 24px;
}

.content_title .title2 {
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  text-align: center;
  color: #999;
}

.content_title .red {
  color: #dc5300;
}

.about {
  background: #fff;
}

.about .about_panel1 .about_img {
  vertical-align: middle;
  width: 49%;
}

.about .about_panel1 .about_img img {
  width: 100%;
  height: 100%;
}

.about .about_panel1 .about_desc {
  padding-left: 30px;
}

.about_title {
  text-align: center;
  height: 45px;
  line-height: 45px;
  font-size: 24px;
  color: #000;
  margin-bottom: 10px;
}

.about .about_panel1 .about_desc .about_line {
  line-height: 30px;
  vertical-align: middle;
  margin-bottom: 20px;
}

.about .about_panel1 .about_desc .about_filed {
  width: 10%;
  color: #999;
  font-size: 16px;
  margin-right: 1%;
}

.about .about_panel1 .about_desc .about_filed_value {
  color: #000000;
  font-size: 16px;
}

.about .about_desc_ {
  margin-top: 20px;
  line-height: 27px;
  color: #0f0f0f;
  /* text-indent: 2em; */
}

.jachu {
  font-weight: bold;
}

.about_desc_ p {
  font-weight: bold;
  margin: 0px;
  font-size: 16px;
  color: #000;
}

.about_desc_item {
  width: 100%;
  /* background: #f8f8f8; */
  border-radius: 1px;
  border: 2px solid #efefef;
  padding: 15px;
  /* cursor: pointer; */
  /* box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.1); */
}

.about_desc_item_split {
  width: 50px;
  height: 10px;
}
</style>
